import { AgentModel } from 'api-hooks/agent';
import * as Yup from 'yup';

export const AgentContactFormSchema = () =>
  Yup.object({
    id: Yup.string(),
    name: Yup.string().default(''),
    email: Yup.string().email().default(''),
    phone: Yup.string().default(''),
    phone_2: Yup.string().default(''),
    description: Yup.string().default(''),

    //additional information
    customId: Yup.string().default(''),
  });

export const AgentBillingFormSchema = () =>
  Yup.object({
    id: Yup.string(),
    name: Yup.string().default(''),
    phone: Yup.string().default(''),
    phone_2: Yup.string().default(''),
    address: Yup.string().default(''),
    bank: Yup.string().default(''),
    accountNumber: Yup.string().default(''),

    //additional information
    customId: Yup.string().default(''),
  });

export const AgentSystemFormSchema = () =>
  Yup.object({
    duePeriod: Yup.number()
      .default(0)
      .transform((value) => (isNaN(value) ? undefined : value)),
    isTransactionLimited: Yup.boolean().default(false),
    transactionLimit: Yup.number()
      .default(0)
      .transform((value) => (isNaN(value) ? undefined : value)),
    remainingTransactionQuota: Yup.number().default(0),
  });

export const AgentFormSchema = () =>
  Yup.object({
    address: Yup.string().default(''),
    balance: Yup.number().transform((value) =>
      isNaN(value) ? undefined : value,
    ),
    phone: Yup.string().default(''),
    phone_2: Yup.string().default(''),
    email: Yup.string().email().default(''),
    name: Yup.string().default(''),
    contacts: Yup.array(AgentContactFormSchema()).default([]),
    system: AgentSystemFormSchema(),
    description: Yup.string().default(''),
    billings: Yup.array(AgentBillingFormSchema()).default([]),
  });

export type AgentFormType = Yup.InferType<
  ReturnType<typeof AgentFormSchema>
> & {
  data?: AgentModel;
};

export type AgentBillingFormType = Yup.InferType<
  ReturnType<typeof AgentBillingFormSchema>
>;

export type AgentSystemFormType = Yup.InferType<
  ReturnType<typeof AgentSystemFormSchema>
>;

export type AgentContactFormType = Yup.InferType<
  ReturnType<typeof AgentContactFormSchema>
>;
